import type { Right } from '@gozoki/tools'
import type { PermissionTuple } from '~/utils/ability'

/**
 * Module 17 — Caméras. Deux fonctionnalités : le flux (écran « Caméras » et les vues caméras
 * personnalisées) et la configuration caméra d'une boutique (écran « Camera Config »).
 */

export const CAMERA_STREAM_READ: PermissionTuple = ['read', 'cameras.cameras.stream']
export const CAMERA_STREAM_ADD: PermissionTuple = ['add', 'cameras.cameras.stream']
export const CAMERA_STREAM_EDIT: PermissionTuple = ['edit', 'cameras.cameras.stream']
export const CAMERA_STREAM_DELETE: PermissionTuple = ['delete', 'cameras.cameras.stream']

export const CAMERA_CONFIG_READ: PermissionTuple = ['read', 'cameras.cameras.config']
export const CAMERA_CONFIG_ADD: PermissionTuple = ['add', 'cameras.cameras.config']
export const CAMERA_CONFIG_EDIT: PermissionTuple = ['edit', 'cameras.cameras.config']
export const CAMERA_CONFIG_DELETE: PermissionTuple = ['delete', 'cameras.cameras.config']

/**
 * Droit v1 exigé tant que le flag `permission-v2` est OFF (où tous les tuples v2 passent) : les
 * endpoints de configuration caméra sont gardés côté backend par
 * `bouncer.with('ResourcePolicy').authorize('admin')`.
 */
export const CAMERA_CONFIG_LEGACY_RIGHTS: Right[] = ['ADMIN']
